import React from 'react'
import { Link } from 'react-router-dom'
import slider1 from '../../../../assets/img/slider1.webp'


function Slidesec1() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Your first step towards transformation</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Your first step  <span>towards transformation</span></h2>
              <p>Our comprehensive Enterprise Application Development & Optimization Services are designed to revolutionize your business value chain, accelerating your journey into the digital realm.

With a wide array of services tailored to meet your diverse needs, 360 Bytes is your one-stop solution for IT transformation:</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider1} alt='Your first step towards transformation' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default Slidesec1
